<script lang="ts">
    import "dayjs/locale/id";
    dayjs.locale("id");

    import Lazy from "svelte-lazy";
    import { MUNIO } from "$lib/munio";
    import { page } from "$app/stores";
    import { dayjs } from "svelte-time";
    import ErrorPage from "$lib/components/section/ErrorPage.svelte";
    import LightPaginationNav from "$lib/components/navigation/nav/LightPaginationNav.svelte";
    import "@splidejs/svelte-splide/css/core";
    import EventsCard from "$lib/components/events/card/EventsCard.svelte";
    import FilterEvents from "$lib/components/events/filters/FilterEvents.svelte";
    import { afterUpdate, onMount } from "svelte";
    import { MUNIO_V2 } from "$lib/munioV2";

    export let data: any = [];
    export let client: any = [];
    export let categories: any = [];
    export let currentNamePage: string = "";
    export let primaryColor: string = "";

    $: items = data.data;
    $: categories = categories;
    let selectedcategory: any;
    let total: number = data.meta?.pagination.total;
    let pageSize: number = data.meta?.pagination.per_page;
    let totalPage: number = data.meta?.pagination.total_pages;
    let currentPage: number = data.meta?.pagination.current_page;

    $: keywordSearch = "";

    let idContent: number = 0;
    let formShareSocialMedia = false;
    let durationTimeCopyToClipboard: any;
    let isCopyToClipboard: boolean = false;

    let openCategory = false;
    const onOpenCategories = () => {
        openCategory = !openCategory;
    };

    let loading: boolean = false;

    async function fetchEvents(page: number) {
        try {
            loading = true;
            window.scroll({
                top: 0,
                behavior: "smooth",
            });
            MUNIO_V2.initMunio(await MUNIO_V2.getClientKey($page.url.origin));
            const res = await MUNIO_V2.getEvent(
                selectedcategory,
                page,
                8,
                keywordSearch,
                "",
                "",
                "",
            );
            if (res) {
                items = res.data;
                currentPage = page;
                total = res?.meta?.pagination?.total;
                pageSize = res?.meta?.pagination?.per_page;
                totalPage = res?.meta?.pagination?.total_pages;
                loading = false;
            }
        } catch (error: any) {
            loading = false;
            throw new Error(error?.message);
        }
    }

    let queryString: any = "";
    let urlParams: any = "";
    let pageParams: any = "";

    onMount(() => {
        queryString = window.location.search ? window.location.search : null;
        urlParams = queryString ? new URLSearchParams(queryString) : null;
        pageParams = urlParams ? Number(urlParams.get("page")) || 1 : 1;
        currentPage = pageParams;
        fetchEvents(pageParams);
    });

    afterUpdate(() => {
        queryString = window.location.search ? window.location.search : null;
        urlParams = queryString ? new URLSearchParams(queryString) : null;
        pageParams = urlParams ? Number(urlParams.get("page")) || 1 : 1;
        if (currentPage !== pageParams) {
            currentPage = pageParams;
            fetchEvents(pageParams);
        }
    });

    const handleCopyLinkToClipboard = (url: string, id: number) => {
        const urlToCopy = url;
        idContent = id;

        navigator.clipboard
            .writeText(urlToCopy)
            .then(() => {
                isCopyToClipboard = true;

                durationTimeCopyToClipboard = setTimeout(() => {
                    isCopyToClipboard = false;
                }, 3000);
            })
            .catch((err) => {
                console.error("Failed to copy URL to clipboard", err);
            });
    };

    const onSubmitSearching = async () => {
        loading = true;
        try {
            MUNIO_V2.initMunio(await MUNIO_V2.getClientKey($page.url.origin));
            const res = await MUNIO_V2.getEvent(
                selectedcategory,
                1,
                8,
                keywordSearch,
                "",
                "",
                "",
            );
            if (res) {
                currentPage = 1;
                items = res?.data;
                total = res?.meta?.pagination?.total;
                pageSize = res?.meta?.pagination?.per_page;
                totalPage = res?.meta?.pagination?.total_pages;
                loading = false;
            }
            loading = false;
        } catch (error: any) {
            loading = false;
            throw new Error(error.message);
        }
    };

    const onDeleteSearching = async () => {
        loading = true;
        try {
            MUNIO_V2.initMunio(await MUNIO_V2.getClientKey($page.url.origin));
            const res = await MUNIO_V2.getEvent(
                selectedcategory,
                1,
                8,
                "",
                "",
                "",
                "",
            );
            if (res) {
                currentPage = 1;
                items = res?.data;
                total = res?.meta?.pagination?.total;
                pageSize = res?.meta?.pagination?.per_page;
                totalPage = res?.meta?.pagination?.total_pages;
                loading = false;
            }
            loading = false;
        } catch (error: any) {
            loading = false;
            throw new Error(error.message);
        }
    };

    const onSetChangeSearch = async (event: any) => {
        keywordSearch = event.target.value;
    };
</script>

<section class="sm:flex gap-8 -mt-6">
    <FilterEvents
        {onSetChangeSearch}
        {onSubmitSearching}
        {onDeleteSearching}
        {keywordSearch}
        {categories}
        {currentNamePage}
        {onOpenCategories}
        {openCategory}
        isCategories={false}
    />

    <div class="lg:w-[80%] sm:w-[70%] w-full">
        {#if loading}
            <div
                class="flex flex-row h-full w-full justify-center items-center"
            >
                <!-- <p>Loading</p> -->
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="xMidYMid"
                    width="100"
                    height="100"
                    style="shape-rendering: auto; display: block; background: transparent;"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    ><g
                        ><circle
                            cx="50"
                            cy="50"
                            fill="none"
                            stroke={`${primaryColor}`}
                            stroke-width="10"
                            r="35"
                            stroke-dasharray="164.93361431346415 56.97787143782138"
                        >
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                repeatCount="indefinite"
                                dur="1s"
                                values="0 50 50;360 50 50"
                                keyTimes="0;1"
                            ></animateTransform>
                        </circle><g></g></g
                    >
                </svg>
            </div>
        {:else}
            {#if items?.length > 0}
                <div
                    class="grid lg:grid-cols-3 xl:grid-cols-4 grid-cols-1 md:grid-cols-2 2xs:grid-cols-1 gap-x-6 gap-y-7"
                >
                    {#each items as data}
                        <a
                            href={`/events/${data?.slug}`}
                            class="no-underline hover:no-underline"
                        >
                            <EventsCard
                                {data}
                                {formShareSocialMedia}
                                {idContent}
                                {currentNamePage}
                                {durationTimeCopyToClipboard}
                                {isCopyToClipboard}
                                {client}
                                {handleCopyLinkToClipboard}
                            />
                        </a>
                    {/each}
                </div>
            {:else}
                <ErrorPage {client} />
            {/if}

            {#if totalPage > 1}
                <div class="mt-10 pagination-wrapper flex justify-start">
                    <LightPaginationNav
                        {pageSize}
                        limit={2}
                        {currentPage}
                        totalItems={total}
                        showStepOptions={false}
                        linkPath={"events"}
                    />
                </div>
            {/if}
        {/if}
    </div>
</section>

<style lang="css">
    :global(.tooltip.custom-tooltip) {
        --tooltip-box-shadow: 0 !important;
        --tooltip-color: white !important;
        font-family: Helvetica, Arial, sans-serif;
    }
    .event-wrapper {
        border: 1px solid #e4e7eb;
    }
    .events__content-category::-webkit-scrollbar {
        display: none;
    }
    .events__content-category {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .pagination-wrapper :global(.pagination-nav) {
        width: fit-content;
        gap: 5px !important;
    }
    .pagination-wrapper :global(.light-pagination-nav) {
        margin: 0 !important;
        padding: 0 0 !important;
        background-color: transparent !important;
    }
    .pagination-wrapper :global(.option.number) {
        font-size: 16px;
        font-weight: 600;
        padding: 8px !important;
        color: #3e3232 !important;
        border-radius: 12px !important;
    }
    .pagination-wrapper :global(.option.number.active) {
        border: 0 !important;
        border-radius: 12px !important;
        background-color: #e9e6e6d7;
    }
    .pagination-wrapper :global(.option.number.active:hover) {
        background-color: #e2dfdf;
    }
    .splide__arrows {
        display: none !important;
    }
    .splide__pagination {
        display: none !important;
    }
</style>
